import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Login component
 * @param {Object} props - LoginComponent properties
 * @param {Function} props.setEmail - function that will store users email in local storage after successful login
 * @param {Function} props.setAccessToken - function that will store users AccessToken in local storage after successful login
 * @param {Function} props.getEmail - function that will attempt to retrieve stored users email in local storage to access the page
 * @param {Function} props.getAccessToken - function that will attempt to retrieve stored users access token in local storage to access the page
 * @returns {JSX.Element} the rendered component
 */


const LoginComponent = (props) => {
    const {
        setEmail,
        setAccessToken,
        getEmail,
        getAccessToken
    } = props;

    const email = getEmail();
    const accessToken = getAccessToken();
    const navigate = useNavigate();

    const [loginError, setLoginError] = useState(false);
    const [loginLoading, setLoginLoading] = useState(false);

    const handleLoginFailure = () => {
        setLoginError(true);
        setLoginLoading(false);
        setTimeout(() => {
            setLoginError(false);
            setLoginLoading(false);
            navigate("/login", { replace: true })
        }, 3000);
    }

    const handleOnRequest = () => {
        setLoginLoading(true);
    }

    const handleGoogleLogin = async (response) => {
        handleOnRequest()
        const {
            credential = '',
        } = response;

        if (credential) {
            const fetchLogIn = await fetch('https://google-auth-node-login-bjudfyf5za-uc.a.run.app/login', { method: "POST", headers: { 'Content-type': 'application/json' }, body: JSON.stringify({ credential: credential, GOOGLE_CLIENT_ID: "495656309447-l15qpfuru9gt0bs335oo1c4vj6ctbv5u.apps.googleusercontent.com" }) });
            const fetchLogInJson = await fetchLogIn.json();
            if (fetchLogInJson && fetchLogInJson.user) {
                if (fetchLogInJson.user.email.includes('servitech.com')) {
                    setEmail(fetchLogInJson.user.email);
                    setAccessToken(fetchLogInJson.user.accessToken)
                    setLoginLoading(false);
                    navigate("/");
                } else {
                    handleLoginFailure();
                }
            } else {
                handleLoginFailure();
            }
        } else {
            handleLoginFailure();
        }
    }

    useEffect(() => {
        if (accessToken && email) {
            navigate("/")
        } else if (window.google) {
            window.google.accounts.id.initialize({
                client_id: '495656309447-l15qpfuru9gt0bs335oo1c4vj6ctbv5u.apps.googleusercontent.com',
                callback: handleGoogleLogin
            });
            window.google.accounts.id.renderButton(
                document.getElementById("googleSignInButtonDiv"),
                { data_theme: "outline", size: "extra_large", shape: "pill", logo_alignment: "left", text: "signin_with" }  // customization attributes
            );
            window.google.accounts.id.prompt();
        }
        // eslint-disable-next-line
    }, [loginError])

    if (loginLoading) {
        return (
            <div className="login-wrapper center-white-message">
                Loading ...
            </div>
        );
    }

    return (
        <div>
            {(!loginError || loginError === 'false') && (
                <div className="login-wrapper align-center">
                    <div id="googleSignInButtonDiv"></div>
                </div>
            )}
            {(loginError || loginError === 'true') && (
                <div className="login-wrapper align-center">Login failed, please try again with a Servitech email.</div>
            )}
        </div>
    )
}
export default LoginComponent;